/*@ngInject*/
const UIHideEmptySectionDirective = function ($timeout) {

    let linkFunction = function ($scope, $elm) {

        const sectionDom = $elm[0];
        const mutationConfig = {
            attributes: false,
            childList: true,
            subtree: true,
            characterData: false,
            characterDataOldValue: false
        };

        const validateContainerSize = () => {
            const sectionHeight = sectionDom.offsetHeight;
            const minHeight = 10;

            if(sectionHeight > minHeight) {
                $elm.removeClass('hideBottomBorder');
            }
            else {
                $elm.addClass('hideBottomBorder');
            }
        };

        const observer = new MutationObserver(validateContainerSize);
        observer.observe(sectionDom, mutationConfig);

        $timeout(function () {
            validateContainerSize();
        }, 300);

        $scope.$on('$destroy', () => {
            observer.disconnect();
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiHideEmptySection', UIHideEmptySectionDirective);
